import { createAsyncThunk } from '@reduxjs/toolkit';

import noteModel from '@/models/note';
import signatureModel from '@/models/signature';
import transactionModel from '@/models/transaction';

export const fetchTransaction = createAsyncThunk(
	'editor/fetchTransaction',
	async (id, { rejectWithValue }) => {
		try {
			const transaction = await transactionModel.getTransactionById(id);

			const { status, metadata, publicId } = transaction;

			return {
				filePath: transactionModel.getBasePdf(transaction)?.path,
				status,
				metadata,
				publicId
			};
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const fetchSignatures = createAsyncThunk(
	'editor/fetchSignatures',
	async (_, { rejectWithValue, getState }) => {
		try {
			const { loggedIn } = getState().profile;

			const signatures = await signatureModel.list(loggedIn);

			return signatures;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const removeNote = createAsyncThunk(
	'editor/removeNote',
	async (data, { rejectWithValue }) => {
		try {
			await noteModel.deleteOne(data.transactionId, data.id);
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const saveNote = createAsyncThunk(
	'editor/saveNote',
	async (data, { rejectWithValue }) => {
		try {
			const { id, transactionId, ...note } = data;

			await noteModel.updateOne(transactionId, id, note);
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const fetchNotes = createAsyncThunk(
	'editor/fetchNotes',
	async (transactionId, { rejectWithValue }) => {
		try {
			const notes = noteModel.getAll(transactionId);

			return notes;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);
